module.exports = __webpack_public_path__ + "static/media/footer.4767d0cd.jpg";